module.exports =
  list: '/camera/list'
  preview: '/camera/:port/preview'
  capture: '/camera/:port/capture'
  reset: '/camera/reset'



// WEBPACK FOOTER //
// ./~/oo-routes/routes/camera.coffee